<template>
    <div class="adjudicate">
        <Row class="detail-header">
            <span>归档</span>
            <Button class="add-btn" v-if="infoCtrl&&isDetailLoad" type="primary" @click="infoCtrl=false">修改</Button>
        </Row>
        <Row class="case-content">
            <Row v-if="!infoCtrl&&isDetailLoad">
                <Form ref="formData" class="case-form" :model="formData" :rules="ruleValidate" :label-width="100">
                    <FormItem label="结案时间" prop="closeTime">
                        <DatePicker
                            transfer
                            type="date"
                            placeholder="请选择结案时间"
                            style="width:100%"
                            format="yyyy-MM-dd"
                            :value="formData.closeTime"
                            @on-change="getTime"></DatePicker>
                    </FormItem>
                    <FormItem label="结案方式" prop="type">
                        <Select v-model="formData.type" placeholder="请选择结案方式">
                            <Option v-for="(item,index) in crnimalCloseTypeArr" :value="item.value" :key="index">{{item.nameZh}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="结案内容" prop="content">
                        <Input v-model.trim="formData.content" type="textarea" :autosize="{minRows: 3,maxRows: 8}" placeholder='请输入结案内容(不超过512个字符)'></Input>
                    </FormItem>
                    <FormItem label="诉讼分析" prop="litigationAnalysis">
                        <Input v-model.trim="formData.litigationAnalysis" type="textarea" :autosize="{minRows: 3,maxRows: 8}" placeholder='请输入诉讼分析(不超过512个字符)'></Input>
                    </FormItem>
                    <FormItem label="结案文书" prop="attachmentList">
                        <file-upload
                                :defaultList="defaultList || []"
                                :uploadConfig="{}"
                                @getFileList="getAttachmentList"></file-upload>
                    </FormItem>
                </Form>
                <Row class="detail-btn-box">
                    <Button type="primary" style="margin-right:10px;" :disabled="isSubmit" @click="submitNew">保存</Button>
                    <Button v-if="defaultData" @click="infoCtrl=true">取消</Button>
                </Row>
            </Row>
            <Row class="detail-content" v-if="infoCtrl&&isDetailLoad">
                <Row><Col span="5" class="left-label">结案时间：</Col><Col span="16" class="right-content">{{defaultData.closeTime}}</Col></Row>
                <Row><Col span="5" class="left-label">结案方式：</Col><Col span="16" class="right-content">{{defaultData.typeName}}</Col></Row>
                <Row><Col span="5" class="left-label">结案内容：</Col><Col span="16" class="right-content">{{defaultData.content}}</Col></Row>
                <Row><Col span="5" class="left-label">诉讼分析：</Col><Col span="16" class="right-content">{{defaultData.litigationAnalysis}}</Col></Row>
                <Row>
                    <Col span="5" class="left-label">结案文书：</Col>
                    <Col span="16" class="right-content">
                        <file-upload
                                :defaultList="defaultData.attachmentList || []"
                                :uploadConfig="{readOnly:true}"></file-upload>
                    </Col>
                </Row>
            </Row>
        </Row>
    </div>
</template>
<script>
export default {
    data () {
        return {
            isDetailLoad:false,
            infoCtrl:true,
            isSubmit:false,
            defaultData:"",
            defaultList:[],
            litigantIdArr:[],
            closeTypeArr:[],
            formData:{
                closeTime:"",
                type:"",
                content:"",
                litigationAnalysis:"",
                attachmentList:[],
            },
            ruleValidate:{
                closeTime:[{ required: true, message: '结案时间不能为空', trigger: 'blur' }],
                type:[{ required: true, message: '结案方式不能为空', trigger: 'blur' }],
                attachmentList:[{ required: true,type:"array", message: '结案文书不能为空', trigger: 'blur' }],
            }
        }
    },
    props: ['processId','caseId'],
    computed:{
        crnimalCloseTypeArr(){
            return this.closeTypeArr.filter(function (item) {
                return item.value == "RE" || item.value == "ME" || item.value == "JU";
            })
        }
    },
    methods: {
        getDetail(){
            let url = '/business/case/criminal/closing/'+this.processId;
            this.$get(url).then(res=>{
                if(res.code==0&&res.data){
                    this.defaultData = res.data;
                    this.infoCtrl = true;
                    this.giveDefaultData();
                }else{
                    this.defaultData = "";
                    this.infoCtrl = false;
                    this.isDetailLoad = true;
                }
            });
        },
        getTime(value){
            this.formData.closeTime = value;
        },
        getAttachmentList(arr){
            this.formData.attachmentList = [];
            arr.forEach((item,index)=>{
                let obj = {
                    fileName:item.fileName,
                    mediaType:item.mediaType,
                    smallUrl:item.smallUrl,
                    url:item.url
                }
                this.formData.attachmentList.push(obj);
            })
        },
        giveDefaultData(){
            this.formData.closeTime = this.defaultData.closeTime;
            this.formData.type = this.defaultData.type;
            this.formData.content = this.defaultData.content;
            this.formData.litigationAnalysis = this.defaultData.litigationAnalysis;

            this.formData.attachmentList = this.defaultData.attachmentList;
            this.defaultList = this.defaultData.attachmentList;

            this.isDetailLoad = true;
        },
        submitNew(){
            let url = "/business/case/criminal/closing";
            let ajaxData = {
                processId:this.processId,
                caseId:this.caseId
            }
            Object.assign(ajaxData,this.formData);
            if(this.defaultData){
                ajaxData.id = this.defaultData.id;
                this.$refs['formData'].validate((valid) => {
                    if(valid){
                        this.isSubmit = true;
                        this.$patch(url,ajaxData).then(res=>{
                            this.isSubmit = false;
                            if(res.code==0){
                                this.getDetail();
                                this.$Message.success("操作成功");
                                this.$emit('reloadProcess');
                            }else{
                                this.$Message.error(res.message);
                            }
                        })
                    }
                })
            }else{
                this.$refs['formData'].validate((valid) => {
                    if(valid){
                        this.isSubmit = true;
                        this.$post(url,ajaxData).then(res=>{
                            this.isSubmit = false;
                            if(res.code==0){
                                this.$Message.success("操作成功");
                                this.$emit('reloadProcess');
                            }else{
                                this.$Message.error(res.message);
                            }
                        })
                    }
                })
            }
        },
        //获取字典数据接口
        async getDictionary(){
            this.closeTypeArr = await this.common.getDictionaryItems('case_close_type');
        },
    },
    created(){},
    beforeMount(){
        this.getDictionary();
    },
    mounted(){
        this.getDetail();
    },
    updated(){},
    components: {},
    watch: {}
}
</script>
<style lang="scss" scoped>
@import '../../civilCase/caseCommon.scss';
</style>



// WEBPACK FOOTER //
// src/view/criminalCase/closeCase/index.vue